<template>
  <div class="page-container">
    <div class="query-title">公关团购订单查询&审批</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #object_id="{ row }">
              <span class="blue" @click="goOrderDetail(row)">{{ row.object_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getGroupOrderList } from '@/api/sap/order-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/groupBuyOrderEditList'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  activated() {
    this.queryData(this.pagination.page, this.$refs.QueryParams.sub())
  },
  methods: {
    goOrderDetail(row) {
      const config = {
        ZS01: '/wly/order/order-quota-check',
        ZS02: '/wly/order/order-noquota-check',
        ZS03: '/wly/order/order-batch-ticket-check',
        ZS04: '/wly/order/order-atmosphere-check',
        ZS05: '/wly/order/order-terminal-group-check',
        ZS06: '/wly/order/order-group-buy-check'
      }

      let path = ''

      if (row.process_type === 'ZS02' && row.zzfld00002j === 'V014') {
        path = config['ZS05']
      } else if (row.process_type === 'ZS02' && (row.zzfld00002j === 'V013' || row.zzfld00002j === 'V015')) {
        path = config['ZS06']
      } else {
        path = config[row.process_type]
      }

      this.$router.push({
        path: path,
        query: {
          object_id: row.object_id
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getGroupOrderList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getGroupOrderList)
      frontExport(this.gridOptions.columns, data, '公关团购订单')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/views/order-manage/groupBuyOrderEditList.vue